module.exports = __webpack_public_path__ + "static/media/favoriteTreat-hug.94d7ce2e.jpg";